import $ from 'jquery';

const $categories = $('.js-categories');
const $categoriesNavigation = $('.js-categories-navigation');

$categoriesNavigation.on('change', function (event) {
  window.location.href = $(this).val();
});
